import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { DateUtils } from 'ng-jhipster';

import { CardType } from '../card-type/card-type.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
import { Card } from '../card/card.model';
import { FreeTrialCardInput } from '../catalog';
@Injectable()
export class OnlineCatalogService extends AbstractEntityService {

    protected resourceUrl = 'api/online-catalog';
    protected resourceCountUrl = 'api/online-catalog/_search/count/card-types';
    private resourceSearchOnlineCatalogNoAuthUrl = 'api/no-auth/_search/online-catalog/card-types';
    private resourceQueryOnlineCatalogNoAuthUrl = 'api/no-auth/online-catalog/schools/schoolId/card-types';
    private resourceQueryOnlineCatalogUrl = 'api/online-catalog/schools/schoolId/student/studentId/card-types';
    private resourceQueryOnlineCatalogOfFreeTrialCardTypesUrl = 'api/online-catalog/free-trial/student/studentId/card-types';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    createFreeTrialCard(input: any): Observable<Card> {
        return this.http
                .post<Card>(this.resourceUrl + '/free-trial/card', input)
                .map((res: Card) => {
                    return res;
                });
    }


    searchOnlineCatalogNoAuth(req?: any): Observable<HttpResponse<CardType[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<CardType[]>>(this.resourceSearchOnlineCatalogNoAuthUrl, options)
            .map((res: HttpResponse<CardType[]>) => res)
            ;
    }

    queryOnlineCatalogNoAuth(schoolId: number, req?: any): Observable<HttpResponse<CardType[]>> {
        if (!schoolId) {
            return;
        }

        let options = this.createRequestOption(req);
        let url = this.resourceQueryOnlineCatalogNoAuthUrl.replace('schoolId', schoolId.toString());
        return this.http.get<HttpResponse<CardType[]>>(url, options);
    }

    queryOnlineCatalog(schoolId: number, studentId: number, req?: any): Observable<HttpResponse<CardType[]>> {
        if (!schoolId || !studentId) {
            return;
        }

        let options = this.createRequestOption(req);
        let url = this.resourceQueryOnlineCatalogUrl.replace('schoolId', schoolId.toString())
                                                    .replace('studentId', studentId.toString());
        return this.http.get<HttpResponse<CardType[]>>(url, options);
    }

    queryOnlineCatalogOfFreeTrialCardTypes(studentId: number, req?: any): Observable<HttpResponse<CardType[]>> {
        if (!studentId) {
            return;
        }

        let options = this.createRequestOption(req);
        let url = this.resourceQueryOnlineCatalogOfFreeTrialCardTypesUrl.replace('studentId', studentId.toString());
        return this.http.get<HttpResponse<CardType[]>>(url, options);
    }

    private convertResponse(res: HttpResponse<CardType[]>): any {
            let jsonResponse = res.body;
            for (let i = 0; i < jsonResponse.length; i++) {
                jsonResponse[i].defaultEndDate = this.dateUtils
                    .convertLocalDateFromServer(jsonResponse[i].defaultEndDate);
                jsonResponse[i].defaultStartDate = this.dateUtils
                    .convertLocalDateFromServer(jsonResponse[i].defaultStartDate);
            }
            return res.clone({body: jsonResponse});
        }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/catalog/online-catalog.service.ts